import { render } from "./admin_discuss.vue?vue&type=template&id=a0e1abc0"
import script from "./admin_discuss.vue?vue&type=script&lang=js"
export * from "./admin_discuss.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__